/* eslint-disable react/no-danger */
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import './pricingAndPackagingHero.scss';
import './rightSizePricingHero.scss';

const ContentWrapper = (props: React.PropsWithChildren<{}>) => (
    <div className="rsp-hero__bg-container">{props.children}</div>
);

export const PricingAndPackagingHero: React.FC = () => (
    <section className="pricing-and-packaging-hero">
        <ContentWrapper>
            <div className="rsp-hero__content-container">
                <header className="rsp-hero__header-boost">
                    <h1>
                        <span>{gettext('EVENTBRITE HELPS YOU')}</span>
                        <br />
                        <strong>{gettext('REACH MORE PEOPLE')}</strong>
                    </h1>
                    <p>
                        {gettext(
                            "Create your event on the world's largest and most trusted events marketplace.  We've got everything you need to sell tickets, manage your events, and attract new attendees all in one place.",
                        )}
                    </p>
                </header>
            </div>
        </ContentWrapper>
    </section>
);

export default PricingAndPackagingHero;
